import { useRouterState } from '@tanstack/react-router'
import { useEffect, useState } from 'react'

export function isElementContentOverflow(element: HTMLElement): boolean {
	const isOverflow =
		element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth
	return isOverflow
}

export function scrollToTop(scrollElement: Element = document.documentElement): boolean {
	const isScrolled = scrollElement.scrollTop !== 0
	let isScrollReset = false

	if (isScrolled) {
		scrollElement.scrollTo({
			top: 0,
			behavior: 'smooth',
		})
		isScrollReset = true
	} else {
		isScrollReset = false
	}

	return isScrollReset
}

export const SCROLL_POSITION_CACHE: Record<string, number> = {}
export function cacheScrollPosition(y: number) {
	SCROLL_POSITION_CACHE[window.location.pathname] = y
}

export function useScrollPostionRestoration() {
	const {
		isLoading,
		isTransitioning,
		location: { pathname },
	} = useRouterState()
	const [isRestored, setIsRestored] = useState<boolean>(false)

	useEffect(() => {
		if (isLoading || isTransitioning) {
			return
		}

		const top = SCROLL_POSITION_CACHE[pathname] ?? 0
		window.scrollTo({ top, behavior: 'instant' })
		setIsRestored(true)
	}, [isLoading, isTransitioning, pathname])

	return isRestored
}
